<nz-select
      nzPlaceHolder="Chọn"
      nzAllowClear
      nzShowSearch
      nzServerSearch
      #input
      (nzOnSearch)="onSearch($event)"
      [nzPlaceHolder]="placeholder"
      [nzDisabled]="disabled"
      (ngModelChange)="optionSelected($event)"
      [(ngModel)]="value"
      [compareWith]="displayFn"
    >
      <ng-container *ngFor="let obj of listObservable | async">
        <nz-option *ngIf="!isLoading" [nzValue]="obj" [nzLabel]="obj.text"></nz-option>
      </ng-container>
      <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
        <i nz-icon nzType="loading" class="loading-icon"></i> Tải dữ liệu...
      </nz-option>
</nz-select>